"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClick = void 0;
const interaction_1 = require("ol/interaction");
const proj_1 = require("ol/proj");
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function useOnClick(callback) {
    const callbackRef = react_1.useRef(callback);
    react_1.useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    const map = useOLMap_1.useOLMap();
    react_1.useEffect(() => {
        const doubleClickInteractions = map
            .getInteractions()
            .getArray()
            .filter(x => {
            return x instanceof interaction_1.DoubleClickZoom;
        });
        doubleClickInteractions.forEach(i => map.removeInteraction(i));
        return () => {
            doubleClickInteractions.forEach(i => map.addInteraction(i));
        };
    }, [map]);
    react_1.useEffect(() => {
        const onClick = (e) => {
            var _a;
            (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef, { coordinates: proj_1.toLonLat(e.coordinate) });
        };
        map.on('click', onClick);
        return () => {
            map.un('click', onClick);
        };
    }, [map]);
}
exports.useOnClick = useOnClick;
//# sourceMappingURL=useOnClick.js.map